<div class="container-fluid" [ngClass]="{ 'bg-light': user }">
    <!-- nav -->
    <nav class="navbar navbar-expand-lg navbar-dark linkedin-navbar" *ngIf="user" aria-label="Main navigation">
        <div class="container-fluid">
            <a class="navbar-brand ms-2" routerLink="/" aria-label="Alliance Assure Home">
                <img class="logo" src="../assets/AllianceInsuranceWebsite.png" height="50" alt="Alliance Assure">
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav"
                aria-controls="mainNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse align-nav" id="mainNav">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0" *ngIf="user.role != 'rsaOperation'">
                    <li class="nav-item">
                        <a class="nav-link active" aria-current="page" routerLink="/" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}" aria-label="Home">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/users" routerLinkActive="active"
                            *ngIf="user.role == 'admin'" aria-label="Dealer management">Dealer</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/users/viewDealer" routerLinkActive="active"
                            *ngIf="user.role == 'dealerOwner'" aria-label="View dealer">Dealer</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/issueCertificate" routerLinkActive="active"
                            aria-label="Create package">Create Package</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/reports/printCertificate" routerLinkActive="active"
                            aria-label="Package list">Package List</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/reports/requestCertificate" routerLinkActive="active"
                            *ngIf="user.role == 'admin'" aria-label="Active request">Active Request</a>
                    </li>
                    <li class="nav-item dropdown"
                        *ngIf="user.role == 'admin' || user.role == 'dealerOwner' || (user.specialRoleAccess && user.specialRoleAccess.includes('CanViewDealerBalanceReport'))">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false" aria-label="Reports menu">
                            Reports
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/reports/certificateReport"
                                    routerLinkActive="active">Package Report</a></li>
                            <li><a class="dropdown-item" routerLink="/reports/dealerBalanceReport"
                                    routerLinkActive="active"
                                    *ngIf="user.role == 'admin' || user.role == 'dealerOwner' || (user.specialRoleAccess && user.specialRoleAccess.includes('CanViewDealerBalanceReport'))">Dealer
                                    Balance Details</a></li>
                            <li><a class="dropdown-item" routerLink="/reports/dealerAggregateReport"
                                    routerLinkActive="active"
                                    *ngIf="user.role == 'admin' || user.role == 'employee' || user.role == 'dealerOwner' || user.role == 'manager'">Dealer
                                    Aggregate Report</a></li>
                            <li><a class="dropdown-item" routerLink="/reports/totalBalanceReport"
                                    routerLinkActive="active"
                                    *ngIf="user.role == 'admin' || (user.specialRoleAccess && user.specialRoleAccess.includes('Can View Package Balance Detail Report') && dealer.dealerCreatePackage)">Package
                                    Balance Details</a></li>
                            <li><a class="dropdown-item" routerLink="/reports/endorsementReport"
                                    routerLinkActive="active" *ngIf="user.role == 'admin'">Modification Report</a>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown" *ngIf="user.role == 'admin'">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownConfigUpdate" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false"
                            aria-label="Configuration Update menu">
                            Configuration Update
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdownConfigUpdate">
                            <li><a class="dropdown-item" routerLink="/configUpdate/rtoList"
                                    routerLinkActive="active">RTO List</a></li>
                            <li><a class="dropdown-item" routerLink="/configUpdate/Finance"
                                    routerLinkActive="active">Finance Company</a></li>
                            <li><a class="dropdown-item" routerLink="/configUpdate/ModelVersion"
                                    routerLinkActive="active">Models</a></li>
                            <li><a class="dropdown-item" routerLink="/configUpdate/Plan"
                                    routerLinkActive="active">Plans</a></li>
                            <li><a class="dropdown-item" routerLink="/configUpdate/PackageId"
                                    routerLinkActive="active">Package Id</a></li>
                            <li><a class="dropdown-item" routerLink="/configUpdate/PrintInstruction"
                                    routerLinkActive="active">Print Instruction</a></li>
                            <li><a class="dropdown-item" routerLink="/configUpdate/State"
                                    routerLinkActive="active">States</a></li>
                            <li><a class="dropdown-item" routerLink="/configUpdate/Package"
                                    routerLinkActive="active">Package</a></li>
                            <li><a class="dropdown-item" routerLink="/configUpdate/InsuranceCompany"
                                    routerLinkActive="active">Insurance Company</a></li>
                            <li><a class="dropdown-item" routerLink="/DealerConfig/DealerPriceList"
                                    routerLinkActive="active">Dealer Price List</a></li>
                            <li><a class="dropdown-item" routerLink="/configUpdate/PremiumCalculation"
                                    routerLinkActive="active">Premium Calculation</a></li>
                        </ul>
                    </li>
                    <li class="nav-item" *ngIf="user.role == 'manager'">
                        <a class="nav-link" routerLink="/users/userList" routerLinkActive="active"
                            aria-label="User maintenance">User Maintenance</a>
                    </li>
                    <li class="nav-item">
                        <button class="nav-link btn btn-link" type="button" (click)="logout()"
                            aria-label="Logout">Logout</button>
                    </li>
                </ul>

                <ul class="navbar-nav me-auto mb-2 mb-lg-0" *ngIf="user.role == 'rsaOperation'">
                    <li class="nav-item">
                        <a class="nav-link active" aria-current="page" routerLink="/" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}" aria-label="Home">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/issueCertificate/rsa" routerLinkActive="active"
                            aria-label="RSA">RSA</a>
                    </li>
                    <li class="nav-item"
                        *ngIf="user.specialRoleAccess && user.specialRoleAccess.includes('CanRenewAllPolicies')">
                        <a class="nav-link" routerLink="/reports/renewCertificate" routerLinkActive="active"
                            aria-label="Renew Certificate">Renew Certificate</a>
                    </li>
                    <li class="nav-item">
                        <button class="nav-link btn btn-link" type="button" (click)="logout()"
                            aria-label="Logout">Logout</button>
                    </li>
                </ul>
            </div>

            <div class="d-flex navbar-dark user-info">
                <p>
                    <i class="fa fa-user user-icon" aria-hidden="true"></i>
                    <button class="btn btn-link navbar-link p-0" type="button" (click)="logout()"
                        aria-label="Logout">&nbsp;{{ " " + user.firstName + " " + user.lastName }}</button>
                </p>
            </div>
        </div>
    </nav>

    <!-- main app container -->
    <main>
        <alert></alert>
        <router-outlet></router-outlet>
    </main>

    <!-- footer -->
    <footer class="mt-4 border-top pt-4">
        <div class="container">
            <div class="row text-center text-md-start">
                <div class="col-md-4 mb-3">
                    <img src="../assets/AllianceLogo.png" class="footer-logo mb-2" height="80" alt="Alliance Assure">
                    <br>
                    <a href="https://AllianceAssure.com" target="_top"
                        aria-label="Visit AllianceAssure.com">AllianceAssure.com</a>
                </div>
                <div class="col-md-4 mb-3">
                    <h6>Quick Links</h6>
                    <ul class="list-unstyled">
                        <li><a href="https://allianceassure.com/terms-conditions/"
                                aria-label="Terms and Conditions">Terms and Conditions</a></li>
                        <li><a href="https://allianceassure.com/privacy-policy/"
                                aria-label="Privacy Policy">Privacy Policy</a></li>
                        <li>
                            <button class="btn btn-link p-0 text-decoration-none" type="button"
                                (click)="cancellationPolicyToggle()"
                                aria-label="Cancellation and Refund Policy">Cancellation/Refund Policy</button>
                        </li>
                        <li><a href="https://allianceassure.com/" aria-label="About Us">About Us</a></li>
                    </ul>
                </div>
                <div class="col-md-4 mb-3">
                    <h6>Support</h6>
                    <ul class="list-unstyled">
                        <li><a href="https://allianceassure.com/contact/"
                                aria-label="Contact Us">Contact Us</a></li>
                        <li>
                            <a href="mailto:support@allianceassure.in"
                                aria-label="Email support">support&#64;allianceassure.in</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="text-center mt-3 pb-3" *ngIf="showCancellationPolicy">
            <small>
                There is no cancellation option for the end users after payment is made. In case of duplicate payment, kindly
                approach us at support&#64;allianceassure.in for refund with proof of the transaction reference / your
                bank statement. Refund will be processed within 10-15 working days. The respective payment
                gateway will send back to the issuing bank [user's card banker] in batches for
                processing, which should approximately take 10-15 working days, depending on issuing
                bank's policies. However, Alliance Assure Pvt Ltd. is not responsible for any delay on the
                bank side.
            </small>
        </div>
    </footer>
</div>
